import * as React from 'react';

export default ({
  children,
  className = '',
  ref,
}: {
  children: React.ReactNode;
  className?: string;
  ref?: React.Ref<HTMLDivElement>;
}) => (
  <div ref={ref} className={`w-full max-w-super mx-auto px-8 ${className}`}>
    {children}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Container.tsx